var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits4Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6673 21.6787V30.9887L35.4887 27.1669L37.8458 29.5239L30.0005 37.3691L22.1554 29.5239L24.5124 27.1669L28.3339 30.9854V21.6787H31.6673ZM19.9746 4.97559C28.2588 4.97559 34.9746 11.6913 34.9746 19.9756V20.0006L33.3339 20.0121L31.6412 20.0107L31.6413 19.9756C31.6413 13.5322 26.4179 8.30887 19.9746 8.30887C13.5313 8.30887 8.30789 13.5322 8.30789 19.9756C8.30789 26.4189 13.5313 31.6422 19.9746 31.6422C20.5879 31.6422 21.1902 31.5949 21.7779 31.5037L24.541 34.2678C23.1012 34.7275 21.5669 34.9756 19.9746 34.9756C11.6903 34.9756 4.97461 28.2598 4.97461 19.9756C4.97461 11.6913 11.6903 4.97559 19.9746 4.97559ZM21.6662 11.6667V19.1L25.9162 21.95L24.0829 24.7167L18.3329 20.9V11.6667H21.6662Z",
    fill: "#FFAC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6681 21.6787V30.9887L35.4896 27.1669L37.8466 29.5239L30.0014 37.3691L22.1562 29.5239L24.5133 27.1669L28.3348 30.9854V21.6787H31.6681Z",
    fill: "#FC6430"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits4Icon);
export default __webpack_public_path__ + "static/media/benefits4 icon.b44c9af603969373677ff0d4a584d813.svg";
export { ForwardRef as ReactComponent };